//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar'


import mainMenuTab from '@/components/mainMenuTab'

export default {
    components: {
        mainMenuTab, navbar,
    },

    data(){
        return {
            orderid: '',
        }
    },
    methods:{

        init(){


        }

    },
    mounted(){
        this.orderid = this.$route.query.orderid.split(",");
    },
}



// WEBPACK FOOTER //
// ./src/views/member/orderSuccess.vue